export default "__VITE_ASSET__D4jDR6bT__"